export const ISendScreenEventUseCaseType = Symbol('ISendScreenEventUseCase');
